import { Router, ActivatedRoute } from "@angular/router";
import {
  Component,
  OnInit,
  ViewChildren,
  AfterViewInit,
  QueryList
} from "@angular/core";
import { LoginService } from "../service/login/login.service";
import { appTitle, loginConfig } from "../config/config";
import { LeafletService } from "../ng-leaflet/services/leaflet.service";
import { NzMenuItemDirective } from "ng-zorro-antd";
import { UtilService } from "../service/util.service";
import { OverlayPanel } from "primeng/primeng";

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {

  public currentUser;
  array = [
    {
      img: "../../../resolution/assets/images/layout/home/地球.png"
    },
    {
      img: "../../../resolution/assets/images/layout/home/卫星.png"
    },
    {
      img: "../../../resolution/assets/images/layout/home/升空.png"
    },
    {
      img: "../../../resolution/assets/images/layout/home/孟轲冰川.png"
    },
    {
      img: "../../../resolution/assets/images/layout/home/月牙泉.png"
    }
  ];


  constructor(
    private loginService: LoginService,
    private router: Router,
  ) {
  }


  _logOut() {
    this.loginService.logout();
    this.router.navigate(["user/login"]);
  }

  // 初始化获取当前登录用户
  ngOnInit() {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.loginService.currentUser.subscribe(data => {
      this.currentUser = data;
    });
  }



  home() {
    this.router.navigate(["home/home"])
  }


  //中心团队
  centerTeam() {
    console.log("我执行了");
    this.router.navigate(["home/centerTeam"])
  }


  //数据介绍
  dataIntroduce() {
    this.router.navigate(["home/dataIntroduce"])
  }

  //环保
  enviromentProtection() {
    this.router.navigate(["home/enviromentProtection"])
  }

  //林业
  forestry() {
    this.router.navigate(["home/forestry"])
  }

  //国土
  land() {
    this.router.navigate(["home/land"])
  }

  //中心新闻
  centerNews() {
    this.router.navigate(["home/centerNews"])
  }

  //行业动态
  industryNews() {
    this.router.navigate(["home/industryNews"])
  }

  //通知公告
  noticeAnnouncement() {
    this.router.navigate(["home/noticeAnnouncement"])
  }


  query() {
    this.router.navigate(["home/dataQuery"])
  }

  cart() {
    this.router.navigate(["home/cart"])
  }

  login() {
    this.router.navigate(["login"])
  }

  concatUs() {

  }
}
